module.exports = __webpack_public_path__ + "media/assets/community/badge-content-leader-941a35b8d87484307c194edb138c1110f9cb2dc44c469ada5e9d3aa2ab7b9e03.png";